import styled, {keyframes} from "styled-components";

import {AiOutlineSend} from "react-icons/ai";

export const spinner = keyframes`

    0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }       

`


export const ContainerHome = styled.div`
    min-height: 100vh;
    width: 100vw;
    background: linear-gradient(135deg, #046d37 0%, #25d366 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;
    overflow-x: hidden;
`

export const MainContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    
    @media (max-width: 768px) {
        flex-direction: column;
        gap: 20px;
        margin: 0;
    }
`

export const LogoHome = styled.img`
    object-fit: contain;
    max-height: 200px;
    max-width: 300px;
    
    @media (max-width: 768px) {
        max-height: 150px;
        max-width: 250px;
    }
`

export const ConnectionCard = styled.div`
    background: white;
    border-radius: 20px;
    padding: 40px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    max-width: 450px;
    width: 100%;
    text-align: center;
    flex-shrink: 0;
    margin: 0 auto;
    @media (max-width: 768px) {
        padding: 24px 12px;
        margin: 0 12px;
    }
`

export const Title = styled.h1`
    color: #046d37;
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 10px;
    text-align: center;
`

export const Subtitle = styled.p`
    color: #666;
    font-size: 16px;
    margin-bottom: 30px;
    text-align: center;
    line-height: 1.5;
`

export const CompanyInfo = styled.div`
    background: #f8f9fa;
    border-radius: 12px;
    padding: 20px;
    margin: 20px 0;
    text-align: center;
    border-left: 4px solid #046d37;
`

export const LoadingMessage = styled.div`
    background: #e3f2fd;
    border-radius: 12px;
    padding: 20px;
    margin: 20px 0;
    text-align: center;
    border-left: 4px solid #046d37;
    color: #046d37;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
`

export const CompanyName = styled.h3`
    color: #046d37;
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 8px 0;
`

export const CompanyDetails = styled.p`
    color: #666;
    font-size: 14px;
    margin: 4px 0;
`

export const ContainerQRCode = styled.div`
    height: 280px;
    width: 280px;
    margin: 30px auto;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
`

export const Qrcode = styled.img`
    height: 260px;
    width: 260px;
    object-fit: contain;
    border-radius: 15px;
`

export const Loading = styled.div`
    margin: auto;
    border: 4px solid #f3f3f3;
    border-radius: 50%;
    border-top: 4px solid #046d37;
    width: 40px;
    height: 40px;
    animation: ${spinner} 1s linear infinite;
`

export const StatusHome = styled.div`
    font-size: 16px;
    color: white;
    margin-top: 20px;
    padding: 15px 25px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 25px;
    backdrop-filter: blur(10px);
    font-weight: 500;
    text-align: center;
    max-width: 400px;
`

export const InputContainer = styled.div`
    display: flex;
    gap: 15px;
    align-items: center;
    margin-bottom: 20px;
    width: 100%;
`

export const InputCNPJ = styled.input`
    flex: 1;
    height: 50px;
    border: 2px solid #e1e5e9;
    border-radius: 12px;
    padding: 0 20px;
    font-size: 16px;
    outline: none;
    transition: all 0.3s ease;
    
    &:focus {
        border-color: #046d37;
        box-shadow: 0 0 0 3px rgba(4, 109, 55, 0.1);
    }
    
    &::placeholder {
        color: #a0a7b0;
    }
    
    &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
`

export const ConnectButton = styled.button`
    height: 45px;
    padding: 0 30px;
    background: linear-gradient(135deg, #046d37 0%, #25d366 100%);
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 120px;
    justify-content: center;
    
    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(4, 109, 55, 0.3);
    }
    
    &:active:not(:disabled) {
        transform: translateY(0);
    }
    
    &:disabled {
        background: #ccc;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
    }
`

export const SuccessMessage = styled.div`
    background: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
    border-radius: 12px;
    padding: 20px;
    margin: 20px 0;
    text-align: center;
    font-weight: 500;
    
    h3 {
        margin: 0 0 10px 0;
        color: #046d37;
    }
    
    p {
        margin: 0;
        font-size: 14px;
    }
`

export const ErrorMessage = styled.div`
    background: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
    border-radius: 12px;
    padding: 15px;
    margin: 15px 0;
    text-align: center;
    font-weight: 500;
`

export const DisconnectButton = styled.button`
    height: 45px;
    padding: 0 25px;
    background: #dc3545;
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    
    &:hover:not(:disabled) {
        background: #c82333;
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(220, 53, 69, 0.3);
    }
    
    &:disabled {
        background: #ccc;
        cursor: not-allowed;
    }
`

export const ReconnectButton = styled.button`
    height: 45px;
    padding: 0 25px;
    background: #17a2b8;
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    
    &:hover:not(:disabled) {
        background: #138496;
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(23, 162, 184, 0.3);
    }
    
    &:disabled {
        background: #ccc;
        cursor: not-allowed;
    }
`

export const ButtonGroup = styled.div`
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    flex-wrap: wrap;
    width: 100%;
    
    @media (max-width: 480px) {
        flex-direction: column;
        
        button {
            width: 100%;
        }
    }
`

export const SendButton = styled(AiOutlineSend)`
    width: 18px;
    height: 18px;
    cursor: pointer;
    user-select: none;
    
    &:active {
        opacity: 0.5;
    }
`